export const spanizeHeadings = () => {
    const headings = [...document.querySelectorAll('[data-spanize]')];

    headings.forEach((node) => {
        const { innerHTML } = node;
        const strArr = innerHTML.split(' ');
        const newInnerHTML = strArr.reduce((acc, cv) => `
            ${acc}
            <span class="step--mask">
                <span class="step--content">
                    ${cv}
                </span>
            </span> 
        `, '');

        node.innerHTML = newInnerHTML;
    });
};

export const spanizeSvgContentHeadings = () => {
    const headings = [...document.querySelectorAll('[data-spanize-svg]')];

    headings.forEach((node) => {
        const { innerHTML } = node;
        const strArr = innerHTML.match(/(<?\D*>)|(\d(,|\.)?)/g).filter((str) => str.length > 0);
        const newInnerHTML = strArr.reduce((acc, cv) => `
            ${acc}
            <span class="svg-step--content">${cv}</span>
        `, '');

        node.innerHTML = newInnerHTML;
    });
};
